<template>
  <div style="padding: 16px">
    <Tabs
      v-model="tabsValue"
      @on-click="handleTapChange"
      style="margin-top: 20px"
    >
      <TabPane
        v-for="(item, index) in cpList2"
        :label="item.name"
        :name="item.name"
        :key="index"
      ></TabPane>
    </Tabs>
    <el-form :inline="true" :model="formFuzzy">
      <el-form-item>
        <el-input
          v-model="formFuzzy.bookName"
          placeholder="输入图书名称"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-input
          v-model="formFuzzy.pressName"
          placeholder="输入出版社名称"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-input
          v-model="formFuzzy.IsbnName"
          placeholder="输入ISBN值"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onQuery" icon="el-icon-search"
          >搜索</el-button
        >
      </el-form-item>
      <!-- <el-button
        class="btn_multy_add_new_book"
        type="primary"
        icon="el-icon-circle-plus-outline"
        v-show="currCPID != null && haveEditCPRight"
        @click="multyAddBook"
        >批量新建图书</el-button
      > -->
      <!-- <el-button
        class="btn_add_new_book"
        type="primary"
        icon="el-icon-circle-plus-outline"
        v-show="currCPID != null && haveEditCPRight"
        @click="addbook"
        >新建图书</el-button
      > -->
    </el-form>

    <el-table
      ref="multipleTable"
      :data="queryData"
      :header-cell-style="rowClass"
      tooltip-effect="dark"
      style="width: 100%; font-size: 12px"
      @selection-change="handleSelectionChange"
      @sort-change="tableSortChg"
      v-loading.body="loading"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column
        prop="id"
        label="ID"
        align="center"
        width="110"
        sortable="custom"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="图书名称"
        align="center"
        min-width="240"
        sortable="custom"
      >
        <template slot-scope="scope">
          <a
            href="javascript:;"
            @click="viewHowEdit(scope.row)"
            style="color: #1d90e6; font-size: 13px"
            >{{ scope.row.name }}</a
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="dbName"
        label="内容提供商"
        align="center"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="clevel"
        label="当前状态"
        width="120"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.clevel == 0" type="danger">已下架</el-tag>
          <el-tag v-else-if="scope.row.clevel == 4" type="gray"
            >审核通过</el-tag
          >
          <el-tag v-else-if="scope.row.clevel == 5" type="success"
            >已上架</el-tag
          >
          <el-tag v-else-if="scope.row.clevel == 2" type="primary"
            >编辑中</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="updated_at"
        label="更新时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.updated_at | formatDate2 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="editor"
        label="编辑账号"
        width="110"
        align="center"
      ></el-table-column>

      <el-table-column
        label="操作"
        show-overflow-tooltip
        align="center"
        width="100"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="查看" placement="top">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-reading"
              circle
              @click="viewHowEdit(scope.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-button
      type="primary"
      @click="borrowBook"
      icon="el-icon-copy-document"
      style="margin-top: 10px"
      >领取</el-button
    >
    <!-- <el-button
      type="primary"
      @click="shangxiajia(5)"
      icon="el-icon-arrow-up"
      style="margin-top: 10px"
      v-show="haveEditCPRight"
      >上架</el-button
    >
    <el-button
      type="info"
      @click="shangxiajia(0)"
      icon="el-icon-arrow-down"
      v-show="haveEditCPRight"
      >下架</el-button
    >
    <el-button
      type="danger"
      @click="handleDelete"
      icon="el-icon-delete"
      v-show="haveEditCPRight"
      >删除</el-button
    > -->
    <div class="pagination-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="queryParams.page"
        :page-sizes="[20, 50, 100]"
        :page-size="queryParams.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { ApiMessage, formatDate } from "@/utils/util";
import { deepObjectCopy } from "@/utils/tools";
export default {
  name: "bookNewList",
  data() {
    return {
      cpList: [],
      cpList2: [],
      shareCPList: [],
      CPIdSet: null,
      queryData: [],
      queryOldData: [],
      queryNewData: [],
      allshareCPLists:[],
      formFuzzy: {
        bookId: "",
        bookName: "",
        dbName: "",
        pressName: "",
        IsbnName: "",
        bookBrand: "",
        state: "",
        cpId: "",
        bookLevel: "",
      },
      statusList: [
        {
          value: 2,
          label: "编辑中",
        },
        {
          value: 4,
          label: "审核通过",
        },
        {
          value: 5,
          label: "已上架",
        },
        {
          value: 0,
          label: "已下架",
        },
      ],
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      pageTotal: 0,
      multipleSelection: [],
      order: "id,desc", //"name,asc",
      loading: true,
      brandList: [],
      currCPID: this.editCPId, //null,
      tabsValue: "",
      haveEditCPRight: false,
      allshareCPList: [],
      allCPList: [],
      queryDatas: [],
      newer: [],
    };
  },
  components: {},
  props: {
    editCPId: {
      type: Number,
      default: null,
    },
    editCPName: {
      type: String,
      default: "",
    },
  },
  created() {
    // debugger
    // this.setCPList();
    this.initCplist();
    this.initCplists()
    // this.fetchQueryDatas()

    // this.fetchQueryData();
  },
  computed: {},
  filters: {
    formatDate2(d) {
      return formatDate(d, "yyyy-MM-dd hh:mm:ss");
    },
  },
  mounted() {},
  watch: {},
  methods: {
    fetchQueryDatas() {
      console.log(111);
      let params;
      let cpid = [];
      //cpid.push(Number(this.$route.query.cpid));
      cpid.push(this.formFuzzy.cpId);
      params = {
        appId: this.$API.APPID,
        dbId: cpid,
        sort: this.order,
        onlyAuthorised: 1,
        dtype: 1,
      };
      params.type = 10;
      params.pageSize = this.queryParams.pageSize;
      params.page = this.queryParams.page;
      // debugger
      this.$axios
        .post("/aries-api/resourceDb/list", params)
        .then((response) => {
          // debugger
          console.log(response);
          if (response.data.result == 0) {
            this.queryDatas = response.data.data.share;
            console.log(this.queryDatas, "this.queryDatas========");
            this.loading = false;
          } else {
            this.loading = false;

            alert(response.data.msg);
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
      // }
    },

    borrowBook() {
      if (this.multipleSelection.length == 0) {
        alert("请先选择书籍");
        return;
      }
      this.checkCopyCPId().then((res) => {
        if (res != null) {
          let dbId = res;
          let len = this.multipleSelection.length;
          let opNum = 0;
          for (let i = 0; i < len; ++i) {
            let params = {
              appId: this.$API.APPID,
              id: this.multipleSelection[i].id,
              dbId: this.multipleSelection[i].dbId,
            };
            this.$axios
              .post("/aries-api/resource/get", params)
              .then((response) => {
                console.log(response);
                let m = response.data;
                if (m.result == 0) {
                  let temp = m.data;
                  temp.appId = this.$API.APPID;
                  temp.src_id = temp.id;
                  temp.id = 0;
                  temp.dbId = dbId;
                  temp.clevel = 2;
                  delete temp.created_at;
                  delete temp.updated_at;

                  this.copySave(temp).then((res2) => {
                    if (res2 != null) {
                      opNum += 1;
                      this.checkOver(opNum);
                    } else {
                      return;
                    }
                  });
                } else {
                  alert(response.data.msg);
                }
              })
              .catch((error) => {
                ApiMessage(this, error.toString(), "error");
              });
          }
        }
      });
    },
    checkOver(num) {
      if (num == this.multipleSelection.length) {
        this.$Message.success("操作成功!");
        this.fetchQueryData();
      }
    },
    initCplists() {
      console.log(555);
      let params = {
        appId: this.$API.APPID,
        //otype: 2,
        dtype: 1,
        onlyAuthorised: 1,
        needAppName: 1,
      };
      this.$axios
        .post("/aries-api/resourceDb/list", params)
        .then((response) => {
          console.log(response,'response===');
          if (response.data.data.length!= 0&&response.data.data.own&&response.data.data.own.length!=0) {
              this.allshareCPLists = response.data.data.own;
              console.log(this.allshareCPLists,'allshareCPLists>>>>>');
              this.getShareCPList();
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },

    checkCopyCPId() {
      return new Promise((resolve, reject) => {
        // let temp = JSON.parse(sessionStorage.getItem("allshareCPLists"));
        let temp=this.allshareCPLists
        console.log(temp,'temp-------');
        if (temp != null) {
          let foundCP = false;
          for (let i in temp) {
            if (temp[i].name == "自有图书库") {
              foundCP = true;
              resolve(temp[i].id);
            }
          }
          if (!foundCP) {
            let params = {
              appId: this.$API.APPID,
              dtype: 1, //选填，cp类型 0 音视频类| 1 书籍类
              name: "自有图书库", //必填
              logo: "", //选填
              is_open: 1, //必填
              otype: 2, //资源库类型，可选值 0系统库  1开发者库   2应用私有库， 选填
              id: 0,
            };
            this.$axios
              .post("/aries-api/resourceDb/save", params)
              .then((response) => {
                console.log(response);
                if (response.data.result == "0") {
                  this.initCplists()
                  resolve(response.data.data.id);
                } else {
                  reject(null);
                }
              })
              .catch((error) => {
                ApiMessage(this, error.toString(), "error");
                reject(null);
              });
          }
        }
      });

    },

    copySave(temp) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post("/aries-api/resource/save", temp)
          .then((response) => {
            console.log(response);
            if (response.data.result == "0") {
              resolve(response.data.data.id);
            } else {
              alert(response.data.msg);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },

    rowClass() {
      return "background:#f9f9f9;color:#000000;font-size:14px;height:22px";
    },
    fetchQueryData() {
      console.log(888);
      let params;
      let cpid = [];
      //cpid.push(Number(this.$route.query.cpid));
      cpid.push(this.formFuzzy.cpId);
      params = {
        appId: this.$API.APPID,
        dbId: cpid,
        sort: this.order,
        // keywords:this.formFuzzy.pressName
      };
      if (this.formFuzzy.bookId != "") {
        let bookid = [];
        bookid.push(Number(this.formFuzzy.bookId));
        params.id = bookid;
      }
      if (this.formFuzzy.bookName != "") {
        params.name = this.formFuzzy.bookName;
      }
      if (this.formFuzzy.bookBrand != "") {
        let brandId = [];
        brandId.push(Number(this.formFuzzy.bookBrand));
        params.tagIds = brandId;
      }
      if (this.formFuzzy.state !== "") {
        params.clevel = Number(this.formFuzzy.state);
      }
      let cpidList = [];
      if (this.formFuzzy.cpId != "") {
        cpidList.push(Number(this.formFuzzy.cpId));
      } 
      else {
        this.allAllCp(cpidList);
      }
      // params.dbId = cpidList;
      var newArr = []//新的数组 获取前100个
        cpidList.forEach((item, index) => {
          // debugger
          if (index <= 99) {
            newArr.push(item)
          }
        })
         params.dbId = newArr;
      if (this.formFuzzy.bookLevel != "") {
        params.keywords = this.formFuzzy.bookLevel;
      }
      if (this.formFuzzy.pressName != "") {
        params.press = this.formFuzzy.pressName;
      }
      if (this.formFuzzy.IsbnName != "") {
        params.isbn = this.formFuzzy.IsbnName;
      }
      params.type = 10;
      params.pageSize = this.queryParams.pageSize;
      params.page = this.queryParams.page;
      params.dbIds;

      this.$axios
        .post("/aries-api/resource/list", params)
        .then((response) => {
          console.log(response);
          if (response.data.result==0&&this.allshareCPList.length!=0) {
            console.log("ccccccccccccccccccccccccccccccccccccnnnnnnnnnnnnnnnnnnnnnnnnnbbbbbbbbbbbbbbbbbbbbbbbbbb");
            this.pageTotal = response.data.data.pager.total;
            this.queryData = response.data.data.list;
            this.loading = false;
          } else {
            this.loading = false;
            // alert(response.data.msg);
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    tableSortChg(val) {
      // debugger
      if (val.order == "descending") {
        this.order = val.prop + ",desc";
      } else if (val.order == "ascending") {
        this.order = val.prop + ",asc";
      }
      this.fetchQueryData();
    },
    allAllCp(cpid) {
      for (let i = 0; i < this.cpList.length; ++i) {
        cpid.push(this.cpList[i].id);
      }
    },
    onQuery() {
      this.queryParams.page = 1;
      // 获取关键字
      this.fetchQueryData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    addbook() {
      if (this.currCPID == null) {
        alert("请切换到具体cp下添加图书");
        return;
      }
      this.$router.push({
        name: "addbook",
        query: {
          cpid: this.currCPID,
          do: "edit",
        },
      });
    },
    handleEdit(book) {
      this.$router.push({
        name: "addbook",
        query: {
          cpid: book.dbId,
          bookid: book.id,
          do: "edit",
        },
      });
    },
    viewHowEdit(book) {
      let routeUrll = this.$router.resolve({
        name: "addbook",
        query: {
          cpid: book.dbId,
          bookid: book.id,
          do: "view",
        },
      });
      window.open(routeUrll.href, "_blank");
    },
    multyAddBook() {
      //这里
      if (this.currCPID == null) {
        alert("请切换到具体cp下添加图书");
        return;
      }
      this.$router.push({
        name: "multyaddbook",
        query: {
          cpid: this.currCPID,
          do: "edit",
        },
      });
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.fetchQueryData();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.fetchQueryData();
    },
    setCPList() {
      console.log(111);
      this.cpList = this.allshareCPList;
      this.setCPlist2();
    },
    setCPlist2() {
      console.log(222);
      let temp = { name: "全部" };
      this.cpList2 = deepObjectCopy(this.cpList);
      this.cpList2.splice(0, 0, temp);
      // debugger
      this.currCPID = null;
      this.tabsValue = this.cpList2[0].name;
      if (this.editCPName != "") {
        console.log(666);
        this.currCPID = this.editCPId;
        this.tabsValue = this.editCPName;
        this.formFuzzy.cpId = this.currCPID;
      } else {
        console.log(7777);
        this.currCPID = null;
        this.tabsValue = this.cpList2[0].name;
        this.formFuzzy.cpId = "";
      }
      this.fetchQueryData();
    },
    initCplist() {
      console.log(555);
      let params = {
        appId: this.$API.APPID,
        //otype: 2,
        dtype: 1,
        onlyAuthorised: 1,
        needAppName: 1,
      };
      this.$axios
        .post("/aries-api/resourceDb/list", params)
        .then((response) => {
          console.log(response);
          console.log(response.data.data);
          if (response.data.data.length!= 0&&response.data.data.share&&response.data.data.share.length!=0) {
            console.log("ciel===========================>>>>>>>>>>");
            this.allshareCPList = response.data.data.share;
            this.getShareCPList();
          }else{
            this.loading=false
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    getShareCPList() {
      console.log(4444);
      if (this.allshareCPList) {
        var temp = this.allshareCPList;
      }
      if (temp != null) {
        this.shareCPList = temp;
      }
      this.setCPList();
    },
    handleTapChange(tabName) {
      if (tabName == "全部") {
        this.currCPID = null;
        this.formFuzzy.cpId = "";
      } else {
        for (let i = 0; i < this.cpList.length; ++i) {
          console.log(this.cpList, "this.cpList=====");
          if (this.tabsValue == this.cpList[i].name) {
            this.currCPID = this.cpList[i].id;
            this.formFuzzy.cpId = this.currCPID;
            if (this.cpList[i].type == "share") {
              this.haveEditCPRight = false;
            } else if (this.cpList[i].type == "own") {
              this.haveEditCPRight = true;
            }
            break;
          }
        }
      }
      this.queryParams.pageSize = 20;
      this.queryParams.page = 1;
      this.fetchQueryData();
    },
    shangxiajia(clevel) {
      if (this.multipleSelection.length == 0) {
        alert("请先选择书籍");
        return;
      }
      let ids = [];
      for (let i in this.multipleSelection) {
        let temp = {
          dbId: this.multipleSelection[i].dbId,
          id: this.multipleSelection[i].id,
        };
        ids.push(temp);
      }
      let param = {
        appId: this.$API.APPID,
        ids: ids,
        clevel: clevel,
      };
      this.sendUpDownBook(param).then((res) => {
        if (res == "success") {
          this.fetchQueryData();
        }
      });
    },
    sendUpDownBook(param) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post("/aries-api/resource/online", param)
          .then((response) => {
            console.log(response);
            if (response.data.result == 0) {
              this.$Message.success("操作成功!");
              resolve(response.data.msg);
            } else {
              alert(response.data.msg);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    handleDelete(id) {
      if (this.multipleSelection.length == 0) {
        alert("请先选择书籍");
        return;
      }
      this.$Modal.confirm({
        title: "确认删除？",
        content: "<ul><li>请确认是否删除书籍</li></ul>",
        onOk: () => {
          let ids = [];
          for (let i in this.multipleSelection) {
            let temp = {
              dbId: this.multipleSelection[i].dbId,
              id: this.multipleSelection[i].id,
            };
            ids.push(temp);
          }
          let params = {
            appId: this.$API.APPID,
            ids: ids,
          };
          this.$axios
            .post("/aries-api/resource/delete", params)
            .then((response) => {
              console.log(response);
              let m = response.data;
              if (m.result == 0) {
                this.fetchQueryData();
                this.$Message.success("删除成功!");
              } else {
                ApiMessage(this, m.msg, "error");
              }
            })
            .catch((error) => {
              ApiMessage(this, error.toString(), "error");
            });
        },
      });
    },
    checkBookEditRight(cpId) {
      for (let i in this.shareCPList) {
        if (this.shareCPList[i].id == Number(cpId)) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../fyd-style.less";
</style>



// WEBPACK FOOTER //
// bookNewList.vue?0520be1c